import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import authInitReducer from "./slices/authInitSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    authInit: authInitReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
